import React from "react";
import { IconButton } from "@chakra-ui/react";
import { MailIcon } from "../../styles/icons";

interface ResendConfirmationEmailButtonProps {
  onClick: () => void;
}

/** Table row action that opens the ResendConfirmationEmailModal. */
export const ResendConfirmationEmailButton = ({
  onClick,
}: ResendConfirmationEmailButtonProps) => (
  <IconButton
    aria-label="Resend email"
    title="Resend email"
    icon={<MailIcon />}
    size="sm"
    variant="ghost"
    onClick={onClick}
  />
);
